import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import Button, { ButtonPrimary } from '../../../../utils/Button';
import { GetTime } from '../../../../utils/Show';
import { ApiReopenSupportTicket } from '../../SupportTicketOperation';
import CloseTicketModal from '../Modals/CloseTicketModal';
import SupportTicketStatus from './SupportTicketStatus';

function InfoRow({ title, value, capitalize }) {
    return (
        <div className="flex">
            <span className="text-sm sm:text-base text-primary-700">{title}:</span>
            <span
                className={`text-sm sm:text-base text-primary font-medium ${
                    capitalize ? 'capitalize' : ''
                }`}
            >
                &nbsp; {value || '--'}
            </span>
        </div>
    );
}

function ActionArea({ data, handleReload, handleCloseTicket, handleReopenTicket }) {
    return (
        <div className="flex items-center gap-x-2">
            <span>
                <ReloadButton className="h-8 sm:h-10 w-8 sm:w-10" onClick={handleReload} />
            </span>
            <span>
                {data?.status === 'closed' ? (
                    <ButtonPrimary
                        title="Re-open Ticket"
                        disabled={data?.demo}
                        onClick={handleReopenTicket}
                    />
                ) : (
                    <Button
                        title="Close Ticket"
                        disabled={data?.demo}
                        className="hover:bg-error bg-transparent border border-error text-error hover:text-white transition-colors"
                        onClick={handleCloseTicket}
                    />
                )}
            </span>
        </div>
    );
}

function HeaderInfo({ data, handleReload, handleCloseTicket, handleReopenTicket }) {
    return (
        <div
            className={`group/customer-details h-auto sm:h-32 mb-4 bg-primary-50 rounded-[10px] p-5 flex flex-col sm:flex-row gap-4 sm:gap-0 justify-between items-start sm:items-center ${
                data?.demo ? 'placeholder-mode' : ''
            }`}
        >
            <div className="flex gap-x-2 items-start">
                <div className="flex items-center gap-x-3">
                    <div>
                        <div className="flex">
                            <span className="text-xl sm:text-2xl">#{data?.id}</span> &nbsp;
                            {!data?.demo && (
                                <span className="text-sm text-primary relative -bottom-2">
                                    _ {GetTime(data?.timeUpdated)}
                                </span>
                            )}
                        </div>
                        {data?.serviceName?.length > 1 && (
                            <InfoRow title="Service Name" value={data?.serviceName} capitalize />
                        )}
                        {data?.subscriptionName?.length > 1 && (
                            <InfoRow
                                title="subscription Name"
                                value={data?.subscriptionName}
                                capitalize
                            />
                        )}
                        <InfoRow title="Subject" value={data?.subject} capitalize />
                        <InfoRow title="Department" value={data?.department} capitalize />
                    </div>
                </div>
                <SupportTicketStatus data={data} />
            </div>
            <div className="flex gap-x-2 items-start">
                <div className="flex items-center gap-x-3">
                    <div>
                        <InfoRow title="Name" value={data?.customerInfo?.organization} capitalize />
                        <InfoRow title="Email" value={data?.customerInfo?.primaryEmail} />
                        <InfoRow title="Role" value={data?.customerInfo?.role} capitalize />
                    </div>
                </div>
                {/* <SupportTicketStatus data={data} /> */}
            </div>

            <ActionArea
                data={data}
                handleReload={handleReload}
                handleCloseTicket={handleCloseTicket}
                handleReopenTicket={handleReopenTicket}
            />
        </div>
    );
}

function PageHeader({ data, handleReload }) {
    const { setConfirm, setMessage, setTemplateLoading } = useTemplate();

    const handleReopenTicket = (e) => {
        e.stopPropagation();
        setConfirm({
            text: 'Are you sure you want to re-open this ticket?',
            textAction: 'Yes',
            clickAction: () => {
                setTemplateLoading(true);
                ApiReopenSupportTicket(data?.id)
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setTemplateLoading(false);
                        setConfirm(null);
                        handleReload();
                    })
                    .catch((err) => {
                        setTemplateLoading(false);
                        setMessage({ type: 'error', text: err.toString() });
                    });
            }
        });
    };

    const handleCloseTicket = (e) => {
        e.stopPropagation();
        setConfirm({
            showButton: false,
            text: <CloseTicketModal data={data} handleReload={handleReload} />
        });
    };

    return (
        <div className="min-h-28">
            <HeaderInfo
                data={data}
                handleReload={handleReload}
                handleCloseTicket={handleCloseTicket}
                handleReopenTicket={handleReopenTicket}
            />
        </div>
    );
}

export default PageHeader;
